export enum LanguajeEnum {
  en = "en",
  es = "es",
}
